import DatePicker from 'react-date-picker';
import dateParseISO from 'date-fns/parseISO';
import dateFormat from 'date-fns/format';
/* eslint-disable react/prop-types */ // TODO: add props

export const EdroloDatePicker = ({
  value,
  onChange,
  displayFormat = 'dd/MM/yyyy',
  saveFormat = 'yyyy-MM-dd',
  ...props
}) => {
  return (
    <div>
      <DatePicker
        value={value ? dateParseISO(value) : null}
        onChange={(date) => {
          if (date) {
            onChange(dateFormat(date, saveFormat));
          } else {
            onChange(null);
          }
        }}
        format={displayFormat}
        {...props}
      />
    </div>
  );
};
